// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let AttributeListV5 = require("./AttributeListV5.bs.js");
let PropertyStrings = require("../../../common/Strings/PropertyStrings.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function PropertyAttributes(props) {
  let fn = param => ({
    value: param[0],
    title: PropertyStrings.displayPropertyAttributeSuffix(param[1])
  });
  let attributes = Stdlib_List.map(props.propertyAttributes, fn);
  return JsxRuntime.jsx(AttributeListV5.make, {
    data: Stdlib_List.toArray(attributes),
    size: props.size
  });
}

let displayAttrSuffix = PropertyStrings.displayPropertyAttributeSuffix;

let make = PropertyAttributes;

exports.displayAttrSuffix = displayAttrSuffix;
exports.make = make;
/* AttributeListV5 Not a pure module */
